import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {DropdownButton, MenuItem} from 'react-bootstrap';

class SortByDropdown extends Component {
    setSortByTitle() {
        const {currentSortColumn} = this.props;

        switch (currentSortColumn) {
            case 'platform_handle':
                return 'Username';
            case 'engagement_rate':
                return 'Engagement Rate';
            case 'engagements':
                return 'Engagements';
            case 'post_user_score':
                return 'My Score';
            case 'avg_post_user_score':
                return 'Avg. Brand Score';
            default:
                return 'Sort By';
        }
    }

    render() {
        const {currentSortColumn, sortByProperty} = this.props;
        const sortByDropdownTitle = this.setSortByTitle();

        return (
            <DropdownButton
                id="dropdown-sort-by"
                className="dropdown-sort-by"
                bsStyle={null}
                title={sortByDropdownTitle}
                noCaret
            >
                <MenuItem
                    eventKey="2"
                    active={currentSortColumn === 'engagement_rate'}
                    onClick={() => sortByProperty('engagement_rate', false)}
                >
                    Engagement Rate
                </MenuItem>
                <MenuItem
                    eventKey="3"
                    active={currentSortColumn === 'engagements'}
                    onClick={() => sortByProperty('engagements', false)}
                >
                    Engagements
                </MenuItem>
                <MenuItem
                    eventKey="4"
                    active={currentSortColumn === 'post_user_score'}
                    onClick={() => sortByProperty('post_user_score', false)}
                >
                    My Score
                </MenuItem>
                <MenuItem
                    eventKey="5"
                    active={currentSortColumn === 'avg_post_user_score'}
                    onClick={() => sortByProperty('avg_post_user_score', false)}
                >
                    Avg. Brand Score
                </MenuItem>
            </DropdownButton>
        );
    }
}

SortByDropdown.propTypes = {
    currentSortColumn: PropTypes.string,
    sortByProperty: PropTypes.func.isRequired
};

export default SortByDropdown;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/sort_by_dropdown.js